import Sidebar from './Sidebar';
import Navbar from './Navbar';
import React from 'react';
import './style.css';
import Table from 'react-bootstrap/Table';

import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { Link } from "react-router-dom";


const EditProducts = () => {

    const navigate = useNavigate();

    const [inputs, setInputs] = useState([]);

    const {id} = useParams();

    useEffect(() => {
        getUser();
    }, []);

    function getUser() {
        axios.get(`https://react-apis.dotlocalhost.com/productShow.php/${id}`).then(function(response) {
            console.log(response.data);
            setInputs(response.data);
        });
    }

    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setInputs(values => ({...values, [name]: value}));
    }
    const handleSubmit = (event) => {
        event.preventDefault();

        axios.put(`https://react-apis.dotlocalhost.com/productShow.php/${id}/edit`, inputs).then(function(response){
            console.log(response.data);
            alert('Record have been updated succefully!');
            navigate('/Products');
        });    
    }

    return(
        <div class="wrapper">
            <Sidebar/>
            <div id="content">
                <Navbar />

                <div className='ineerBody'>

                    <div className='row'>
                        <div className='col-md-12 mb-5'>
                            <h3>Edit Products</h3>
                        </div>
                    </div>

                    <form onSubmit={handleSubmit}>
                        <Table cellSpacing="10">
                            <tbody>
                                <tr>
                                    <th>
                                        <label>Product Name: </label>
                                    </th>
                                    <td>
                                        <input value={inputs.productName} className='form-control' type="text" name="productName" onChange={handleChange} />
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <label>Packing: </label>
                                    </th>
                                    <td> 
                                        <select class="form-select" className='form-control' aria-label="Default select example" name="packing" value={inputs.packing} onChange={handleChange}>
                                            <option selected> Select Packing </option>
                                            <option value="Bags">Bags</option>
                                            <option value="Cartons">Cartons</option>
                                            {/* <option value="3">Three</option> */}
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <label>Net Weight: </label>
                                    </th>
                                    <td>
                                        <input value={inputs.netWeight} type="text" name="netWeight" className='form-control' onChange={handleChange} />
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan="2" align ="right">
                                        <Link to={`/Products`} style={{marginRight: "10px"}} class="btn btn-warning">Cancle Edit</Link>
                                        <button class="btn btn-success">Update</button>
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </form>

                </div>

            </div>
        </div>
    )
}

export default EditProducts;